import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { setCarrierSettingPopup } from "../../actions/user";
import { CarriersRules } from "../../modules/AutoAssignCarrier";
import {
	Button,
	Dialog,
	DialogActions,
	Slide,
} from "../../utils/barrels/material-ui-core";
import { CloseIcon } from "../../utils/barrels/material-ui-icons";

const Transition = React.forwardRef((props, ref) => (
	<Slide direction="down" ref={ref} {...props} />
));
Transition.displayName = "Transition";

function AssignCarrierPopup(props) {
	const { carrier_setting_required } = props.user;
	const [showButton, setShowButton] = useState(false);
	const closeModel = () => {
		props.setCarrierSettingPopup({
			carrier_setting_required: false,
		});
		localStorage.removeItem("client_id");
		window.location.reload();
	};
	return (
		<Dialog
			fullScreen
			open={carrier_setting_required}
			onClose={(e, reason) => {
				if (reason === "backdropClick") {
					e.preventDefault();
					e.stopPropagation();
					closeModel();
				}
			}}
			TransitionComponent={Transition}
			keepMounted
		>
			{showButton && (
				<DialogActions>
					<Button color="primary" onClick={() => closeModel()}>
						<CloseIcon />
					</Button>
				</DialogActions>
			)}
			{carrier_setting_required && (
				<CarriersRules
					closeModel={() => {
						closeModel();
					}}
					showCloseButton={(val) => setShowButton(val)}
				/>
			)}
		</Dialog>
	);
}

const mapDispatchToProps = {
	setCarrierSettingPopup: (obj) => setCarrierSettingPopup(obj),
};

const mapStateToProps = (state) => ({
	appEngine: state.appEngine,
	user: state.user,
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(AssignCarrierPopup)
);
